import React from "react";

export default function DescriptionComponent({ data }) {
  return (
    <div className="container-info mt-3">
      <div style={{ fontSize: 14, fontWeight: "600" }}>Keterangan</div>
      <div style={{ marginTop: 24 }}>
        {data &&
          data.map((item, index) => {
            return (
              <div className="d-flex">
                <div style={{ flex: 1 }}>{index + 1}.</div>
                <div style={{ flex: 20 }}>{item}</div>
              </div>
            );
          })}
      </div>
    </div>
  );
}
